import { isConflictError, isConflictErrorWithFields } from '@wkda/funnel-utils';
import { hasGlobalError, isConflictStatusCode } from '../shared';
const PENDING_EVALUATION_ERROR = 'Customer has one or more pending self-evaluations';
const OLD_CAR_ERROR = 'Missing dat_ecode for carHash';
const LP_IDENTIFICATION_ERROR = 'Cannot identify license plate in vehicle-identification';
const INVALID_PHONE_ERROR = 'Invalid phone number';
const VIN_NOT_RECOGNIZED_ERROR = 'vinNotRecognized';
const VIN_ALREADY_SUBMITTED_ERROR = 'The VIN update was already submitted';
export function isPendingSelfEvalutationError(_ref) {
  let {
    result = {},
    statusCode
  } = _ref;
  return isConflictStatusCode(statusCode) && hasGlobalError(result, PENDING_EVALUATION_ERROR);
}
export function isOldCarError(_ref2) {
  let {
    result = {},
    statusCode
  } = _ref2;
  return isConflictStatusCode(statusCode) && hasGlobalError(result, OLD_CAR_ERROR);
}
export function isDOIError(obj) {
  const {
    result = {},
    statusCode
  } = obj;
  return isConflictStatusCode(statusCode) && result.inDoi === true;
}
export function isResubmitPriceAliveError(obj) {
  const {
    result = {},
    statusCode
  } = obj;
  return isConflictStatusCode(statusCode) && result.isResubmitPriceAlive === true;
}
export function isConflicErrorWithFields(obj) {
  const {
    statusCode,
    result = {}
  } = obj;
  return isConflictStatusCode(statusCode) &&
  // eslint-disable-next-line eqeqeq
  result.globalErrors != undefined &&
  // eslint-disable-next-line eqeqeq
  result.fieldErrors != undefined;
}
export function isLPIdentificationError(obj) {
  const {
    result = {},
    statusCode
  } = obj;
  return isConflictStatusCode(statusCode) && hasGlobalError(result, LP_IDENTIFICATION_ERROR);
}
export function isPhoneConflict(obj) {
  return isConflictErrorWithFields(obj) && (obj.response?.data.fieldErrors ?? []).some(conflict => {
    return conflict.field === 'user.phoneNumber';
  });
}
export function isInvalidPhoneNumberError(obj) {
  return isConflictError(obj) && hasGlobalError(obj.response?.data, INVALID_PHONE_ERROR);
}
export function isVinFieldConflictError(obj) {
  const {
    result = {},
    statusCode
  } = obj;
  return isConflictStatusCode(statusCode) && result.fieldErrors?.['vehicle.vin']?.message;
}
export function isVinConflict(obj) {
  return isConflictErrorWithFields(obj) && hasGlobalError(obj?.response?.data, VIN_NOT_RECOGNIZED_ERROR);
}
export function isVinAlreadyUpdatedError(result) {
  return isConflictErrorWithFields(result) && result?.response?.data && hasGlobalError(result.response?.data, VIN_ALREADY_SUBMITTED_ERROR);
}